// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.SelectField = (function () {
  var _super;
  function SelectField(cfg, index, form) {
    // must be done like this so we can further extend (eg. ReportValueField)
    // this._super would refer to SelectField
    SelectField.prototype._super.apply(this, arguments); // call generic TextField constructor
  }
  SelectField.prototype = {
    emptyLabel: null,
    emptyValue: "",
    data: false, // format: [{name: <String>, value: <Primitive>, style: <String>, class: <String>, icon: <String>}]
    initialValue: "", // if === false, select a blank value
    title: "",
    classes: [],
    bsOptions: {},
    multiple: false, // whether we can select multiple values
    selectedTextFormat: null, // see bootstrap-select
    mandatory: false,

    searchable: false,
    searchPlaceholder: null,
    noneFoundText: null,
    onNoneFoundClick: null, // function to call when noneFound element is clicked
                            // signature: function(<String> searchedValue, <SelectField> instance)
    alwaysShowNoneFound: false, // show noneFound even if results were found
    
    loadUrl: null, // API url to load data from - if set, .data is ignored
    loadLabel: null,
    loadTransform: null, // function to run data from API through before using as .data
    onLoad: null, // called whenever the data is loaded from remote. Signature (opt[] data)
    valueIsEntireOption: false, // whether we should return the entire option ({ value: X, name: Y }) in .getValue()

    // TODO: Line separaters?
    // TODO: Limit dropdown list
    // TODO: Validate?

    _template: 
      '<div class="form-group <%=classes.join(" ")%>">' +
        '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
        '<div class="col-sm-9">' +
          '<select id="<%=id%>" name="<%=name%>" class="form-control selectpicker needsclick <%=classes.join(" ")%>" '+
            'value="<%=initialValue%>" '+
            '<% if (multiple) { %>multiple<%}%> '+
            '<% if (selectedTextFormat) {%>data-selected-text-format="<%=selectedTextFormat%>"<% } %> '+
          '>'+
          '</select>'+
        '</div>' +
      '</div>'
  };
  SelectField.prototype._get$Element = function(){
    _super.prototype._get$Element.apply(this, arguments);
    var self = this;

    // bind specific listeners to our element
    this.$inp = $("#"+this.id,this.$elm);
    this.$inp.data("SelectField", this);
    this.$inp.on("change", function(){
      // first remove any old classes from the previous option
      if (self._optClasses && self._optClasses.length) {
        self.$bsSelect.removeClass(self._optClasses.join(" "));
      }

      // then add classes from the new option
      var $_self = $(this),
          selectedOpt = this.options[this.selectedIndex],
          classes = $(selectedOpt).attr("class");
      if (classes) {
        classes = classes.split(" ")
                  .filter(function(v){
                    return !$_self.hasClass(v);
                  });
        self.$bsSelect.addClass(classes.join(" "));
      }

      // classes is now an array of classes we don't have
      self._optClasses = classes;

      // also remove feedback classes
      self.$bsSelect.removeClass("has-feedback has-error has-warning has-success shake");
    });

    // add items immediately if we don't load them from elsewhere
    if (!this.loadUrl) {
      if (this.data) {
        this._setListItems(this.data, true);
      }
    }

    // then turn it into a bs-select
    this.$inp.selectpicker($.extend({
      header: this.title,
      noneSelectedText: this.emptyLabel,
      noneResultsText: this.noneFoundText,
      liveSearch: this.searchable,
      liveSearchPlaceholder: this.searchPlaceholder,
      iconBase: "fa",
      tickIcon: "fa-check",
      countSelectedText: this.countSelectedText
    }, this.bsOptions));

    // bootstrap-select doesn't expose a search event - hook into it anyway
    this.$bsSelect = this.$inp.closest(".bootstrap-select");
    this.$bsSelectIcon = $("span.caret", this.$bsSelect);
    this.$bsMenu = this.$bsSelect.data("this").$menu;
    $(".bs-searchbox input", this.$bsMenu)
      .on("input", this._replaceNoResults.bind(this));

    // FastClick breaks option selection if this isn't done
    $(".dropdown-toggle *, .dropdown-toggle", this.$bsSelect).addClass("needsclick");

    // bs-select tries to parse data attributes (again) if we don't remove class
    this.$inp.removeClass("selectpicker").addClass("hidden");

    // bind shown event so we can force focus in search field:
    var self = this;
    this.$inp.on("shown.bs.select", $.proxy(function() {
      var field = this, search,
          $search = field.$bsMenu.find(".bs-searchbox input");

      if ($search.length > 0) {
        search = $search[0];

        if (!self.multiple && !isFinite(field.getValue())) {
          $search.val(field.getValue());
        }

        search.focus && search.focus();
        search.select && search.select();
      }
    },this));

    if (this.loadUrl) {
      this.load();
    } else {
      this.$inp.trigger("change");
    }

    this.$inp.on("change", this.validate.bind(this) );

    return this.$elm;
  };

  /**
   * Load data from a remote API
   */
  SelectField.prototype.load = function() {
    var self = this;

    // stop any in-flight requests
    if (this._xhr) {
      this._xhr.abort();
    }

    // start animating
    var _shouldClear = !this.loading; // don't stop loading afterwards if we were loading at the start
    this.setLoading(true);

    // load the stuff
    this._xhr = $.ajax({
      url: this.loadUrl,
      dataType: "json",
      success: function(data){
        data = self.loadTransform ? self.loadTransform(data) : data;
        if (data && data.length) {
          self._setListItems(data);
        } else {
          self.addOneTimeItem({
            value: "",
            name: self.emptyLabel
          });
        }
        if (self.onLoad) { self.onLoad(data); }
      },
      error: function(){
        self.addOneTimeItem({
          value: "",
          name: null
        });
      },
      complete: function(){
        if (_shouldClear) {
          self.setLoading(false);
        }
      }
    });

    this.addOneTimeItem({
      value: "",
      name: this.loadLabel
    });
  };

  /**
   * Replaces bootstrap-select's default .no-results element with our own
   */
  SelectField.prototype._replaceNoResults = function() {
    var self = this;
    if (this.onNoneFoundClick) {
      if (this.$noResults) {
        this.$noResults.remove();
      }

      var $noResults = $(".no-results", this.$bsMenu);
      if (!$noResults.length && this.alwaysShowNoneFound) {
        var searchVal = $(".bs-searchbox input", self.$bsMenu).val();
        if (searchVal) {
          var activeVal = $("li.active", self.$bsMenu).text();
          if (searchVal.trim() !== activeVal.trim()) {
            $noResults = this.$noResults = $('<li style="display: list-item;"></li>');
            $noResults.appendTo(this.$bsMenu)
              .text(
                PD.utils.curlyFormat(this.noneFoundText, [searchVal])
              );
          }
        }
      }

      if ($noResults.length) {
        $noResults
          .addClass("no-results-clickable")
          .click(function(){
            self.onNoneFoundClick(
              $(".bs-searchbox input", self.$bsMenu).val(),
              self
            );
          });
      }
    }
  };

  /**
   * Update items to match data array
   * @param  {Array} data  Items to add. See _addListItems.
   */
  SelectField.prototype._setListItems = function(data, noRefresh) {
    if (!noRefresh) {
      this._clearList(); // remove existing
    }

    if (data.length) {
      this._addListItems(data, true); // add new options
      this.$inp.prop("disabled", false);
      // if initialValue === false, add empty label
      if (this.initialValue === false) {
        var $opt = $('<option data-hidden="true" selected></option>')
          .prependTo(this.$inp);
      }

      if (!noRefresh) {
        this.$inp
          .removeClass("hidden")
          .selectpicker("refresh")
          .addClass("hidden")
          .trigger("change");
      }
    } else {
      // if given an empty array, we still want to be able to open the empty dropdown
      this.$inp.prop("disabled", false);
      if (!noRefresh) {
        this.$inp.trigger("change");
      }
    }
  };

  /**
   * Add items to our select. Item format is
   * {
   *   value: <String>,
   *   limit: <String>,
   *   name: <String>,
   *   selected: <Bool>,
   * }
   * @param {Array}  items  Items to add
   */
  SelectField.prototype._addListItems = function(items, noRefresh) {
    items = [].concat(items);

    var str = "";
    this.data = (this.data || []).concat(items);
    for (var i = 0; i < items.length; i++) {
      if (!items[i]) {
        continue;
      }

      var item = items[i],
          selected = item.value === this.initialValue && item.value !== false;
      str += '<option '+
        'class="'+(item.class || '')+'" '+
        'style="'+(item.style || '')+'" '+
        'data-icon="'+(item.icon || '')+'" '+
        'data-hidden="'+(item.hidden === true)+'" '+
        'value="'+(item.value!==undefined?item.value:"")+'" '+
        ((item.selected===true)?'selected ':'')+
        (selected ? 'selected="selected"' : '')+
        '>' +
          (item.name||"")+
        '</option>';
    }
    $(str).appendTo(this.$inp);

    if (!noRefresh) {
      this.$inp.removeClass("hidden")
        .selectpicker("refresh")
        .addClass("hidden")
        .trigger("change");
    }
  };

  /**
   * Adds a one-time item. The item will be immediately selected, but not added to the select
   * @param {Object} item  Item of the usual format
   */
  SelectField.prototype.addOneTimeItem = function(item) {
    if (this._$oneTime) { this._$oneTime.remove(); }
    var $opt = this._$oneTime = $('<option data-hidden="true" value="'+
            (item.value!==undefined ? item.value : "")+
          '" selected>'+(item.name||"")+'</option>');
    
    $("option[selected]", this.$inp).removeAttr("selected");
    this.$inp.append($opt)
      .removeClass("hidden")
      .selectpicker("refresh")
      .addClass("hidden");
    // $opt.removeAttr("selected");
  };

  SelectField.prototype._setFeedback = function() {};

  /**
   * Clears the list, removing data and disabling input
   */
  SelectField.prototype._clearList = function() {
    this.$inp.empty();
    this.$inp.prop("disabled", true);
    this.$inp.selectpicker("val", this.emptyValue);
  };

  /**
   * Disables the select, or enable if `enable` is `true`
   */
  SelectField.prototype.disable = function(enable) {
    this.$inp.prop("disabled", !enable);
    this.$inp.removeClass("hidden")
      .selectpicker("refresh")
      .addClass("hidden");
  };

  // generic overwrite of super method
  SelectField.prototype.validate = function() {
    this.$elm.removeClass("has-feedback");

    if (this.mandatory && this.getValue() === this.emptyValue) {
      this.$elm.addClass("has-feedback");
      return false;
    }

    return true;
  };
  /**
   * Set the selected item to the one with the given value
   * @param {String}  value                    The value to select
   */
  SelectField.prototype.setValue = function(value) {
    this.$inp.selectpicker("val", value);
  };

  // generic overwrites of _super methods
  SelectField.prototype.getValue = function() {
    var vals = this.$inp.selectpicker("val");
    if (this.valueIsEntireOption && vals instanceof Array) {
      var options = [];
      var seenVals = {};
      for (var i = 0; i < this.data.length; ++i) {
        var opt = this.data[i];
        if (vals.indexOf(opt.value) !== -1 && !seenVals[opt.value]) {
          seenVals[opt.value] = true;
          options.push(opt);
        }
      }
      return options;
    }
    return vals;
  };

  /**
   * Sets the state of the loading animation
   * @param {Boolean} value  Whether or not the field is currently loading
   */
  SelectField.prototype.setLoading = function(value) {
    this.loading = value;
    this.$bsSelectIcon
      .toggleClass("caret", !value)
      .toggleClass("fa fa-spinner fa-spin", value);
  }

  // inherit from generic field
  PD.forms.fields.register(["select", "SelectField"], SelectField);
  _super = SelectField.prototype._super;

  return SelectField;
})();
